import {NgbDate, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { AbstractCustomControl, MakeProvider } from '../abstract-custom-control';
import { Focusable } from './../../interfaces/focusable';
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { UserService } from '../../base-services/user.service';
import { ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgbDateSrParserFormatter } from './../date-picker-popup/ngb-date-sr-parser-formatter';
import { DateRange } from '../../base-models/date-range';

@Component({
  selector: 'yt-fw-date-range-picker-popup',
  templateUrl: './date-range-picker-popup.component.html',
  providers: [
    MakeProvider(DateRangePickerPopupComponent),
    { provide: NgbDateParserFormatter, useClass: NgbDateSrParserFormatter}
  ],
  styles: [`
    .form-group.hidden {
      width: 0;
      margin: 0;
      border: none;
      padding: 0;
    }
    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})

export class DateRangePickerPopupComponent
extends AbstractCustomControl<any>
implements Focusable, OnInit {

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  period: DateRange=new DateRange();

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected userService: UserService,
    public ngbDateParserFormatter: NgbDateParserFormatter)
     {
    super(changeDetectorRef);
  }

  @ViewChild('inputControl', { static: true }) inputControl: ElementRef
  @ViewChild('dpFromDate', { static: true }) dpFromDate: ElementRef
  @ViewChild('dpToDate', { static: true }) dpToDate: ElementRef
  @ViewChild('placeholder', { static: true }) placeholder: ElementRef
  @ViewChild('errorIcon', { static: true }) errorIcon: ElementRef;
  @ViewChild('placeholderTo', { static: true }) placeholderTo: ElementRef
  @ViewChild('errorIconTo', { static: true }) errorIconTo: ElementRef;
  @ViewChild('toggleButton', { static: true }) toggleButton: ElementRef;
  @ViewChild('clearButton', { static: false }) clearButton: ElementRef;
  @ViewChild('d', { static: true }) datePicker: any;

  @Input() MinDate: NgbDate = new NgbDate(1900, 1, 1);
  @Input() MaxDate: NgbDate = new NgbDate(2999, 12, 31);
  @Input() LabelTo: string;


  @Output() OnDateSelected = new EventEmitter();

  

  private allowedKeyCodes: number[] = [
    48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
    96, 97, 98, 99, 100, 101, 102, 103, 104, 105,

    //backspace
    8,

    //arrows
    37, 39,

    //tab
    9,

    //delete
    46,

    //home
    36,

    //end
    35,

    //down
    40
  ]

  onDateSelection(date: NgbDate) {
    let closePickser:boolean=false;
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      closePickser=true;
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    
    this.refreshControlSource();
    if (closePickser)
    this.datePicker.close();
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  ngOnInit() {
  }

  dateChanged(value){
    if((!value.after(this.MinDate) || !value.before(this.MaxDate)) && (!value.equals(this.MinDate) && !value.equals(this.MaxDate))){
      this.value = this._oldValue;
      alert('Datum van opsega.' + 'Min: ' + this.MinDate.day + '/' + this.MinDate.month + '/' + this.MinDate.year + '. Max: ' + this.MaxDate.day + '/' + this.MaxDate.month + '/' + this.MaxDate.year);
      return;
    }
      this.OnDateSelected.emit(value);
  }

  writeValue(value){
    super.writeValue(value);
    
    if (value)
    {
      if (value.FromDate)
        this.fromDate=value.FromDate;
      if (value.ToDate)
        this.toDate=value.ToDate;
    }

    this.OnDateSelected.emit(value);
  }

  onBlur(event){
    let wrongFormat:boolean=false;
    let valueForCheck=event.srcElement.value;
    const itIsFromDate:boolean=event.srcElement.name=="dpFromDate";

    if (valueForCheck)
    {
      if (!valueForCheck.day)
      {
        valueForCheck=this.ngbDateParserFormatter.parse(valueForCheck);
      }
      if (valueForCheck)
      {
        const date = new NgbDate(valueForCheck.year, valueForCheck.month, valueForCheck.day);
        if((date.after(this.MinDate) || date.equals(this.MinDate))
        && (date.before(this.MaxDate) || date.equals(this.MaxDate)))
        {
          wrongFormat=(itIsFromDate && date.after(this.toDate))
            || (!itIsFromDate && date.before(this.fromDate));
          
          if (wrongFormat)
          {
            alert('Prvi datum je veći od drugogo.');
          }

        }
        else
        {
          alert('Datum van opsega.' + 'Min: ' + this.MinDate.day + '/' + this.MinDate.month + '/' + this.MinDate.year + '. Max: ' + this.MaxDate.day + '/' + this.MaxDate.month + '/' + this.MaxDate.year);
          wrongFormat=true;
        }
      }
      else
      {
        alert('Nekompletan datum.');
        wrongFormat=true;      
      }

    }
    else
    {}

    if (wrongFormat)
    {
      if (event.srcElement.name=="dpFromDate")
      {
        this.fromDate=null;
        this.dpFromDate.nativeElement.focus();
      }
      else
      {
        this.toDate=null;
        this.dpToDate.nativeElement.focus();
      }
    }
    else
    {
      if (event.srcElement.name=="dpFromDate")
        this.fromDate=valueForCheck;
      else
        this.toDate=valueForCheck;

      // this.refreshControlSource();
    }
    this.refreshControlSource();

  }

  refreshControlSource(){
    this.period.FromDate=this.fromDate;
    this.period.ToDate=this.toDate;
    // if (this.fromDate && this.toDate)
    //   this.value=this.period;
    // else
    //   this.value=null;

    this.value=this.period;

    this.OnDateSelected.emit(this.value);
  }

  toggle(d){
    d.toggle();
  }

  onKeydown(event){
    if(event.keyCode == 40){
      this.datePicker.open();
    }
    else if(this.allowedKeyCodes.indexOf(event.keyCode) == -1 && event.key != this.userService.GetDateSeparator())
    {
      
        event.stopPropagation();
        event.preventDefault();
        return;
     }
     else{
       this.datePicker.close();
     }
  }


  ngAfterViewInit(){
    this.setSize();
  }

  setSize(){
    // if(this.inputControl.nativeElement.offsetWidth > 0){
    //   this.placeholder.nativeElement.style.width = this.inputControl.nativeElement.offsetWidth + 'px';
    //   this.errorIcon.nativeElement.style.left = this.inputControl.nativeElement.offsetWidth - 5 + 'px';
    // }

    if(this.dpFromDate.nativeElement.offsetWidth > 0){
      this.placeholder.nativeElement.style.width = this.dpFromDate.nativeElement.offsetWidth + 'px';
      this.errorIcon.nativeElement.style.left = this.dpFromDate.nativeElement.offsetWidth - 5 + 'px';
    }

    if(this.dpToDate.nativeElement.offsetWidth > 0){
      this.placeholderTo.nativeElement.style.width = this.dpToDate.nativeElement.offsetWidth + 'px';
      this.errorIconTo.nativeElement.style.left = this.dpToDate.nativeElement.offsetWidth - 5 + 'px';
    }

  }
}